import React, {useState, useEffect, useContext} from 'react';
import styled from "styled-components";
import {Icon} from "react-materialize";
import useFetch from "../Utilities/API/useFetch.react";
import AppContext from "../Context/AppContext.react";
import Tenant from "../Components/Tenants/Tenant.react";

const TenantSelectionPage = styled.div`
  padding-top: 3rem;
  padding-bottom: 3rem;
  
  .header {
    margin-left: auto;
    margin-right: auto;
    width: 58rem;
    text-align: center;
  }

  h1 {
      color: #515151;
      font-size: 3.5rem;
      font-weight: 400;
      letter-spacing: 2px;
  }
  
  p {
    text-wrap: none;
    display: flex;
    align-items: center;
    justify-content: center;
    i {
      font-size: 2rem;
    }
  }
  
  .tenants-container {
    width: 58rem;
    margin-left: auto;
    margin-right: auto;
  }
`

const TenantSelection = () => {
  const {tenant, setTenant} = useContext(AppContext);
  const [fetchUrl] = useFetch();
  const [tenants, setTenants] = useState([])
  const [selectedTenant, setSelectedTenant] = useState({})

  const handleClick = (tenantObject) => {
    setTenant(tenantObject);
    setSelectedTenant(selectedTenant);
  }

  useEffect(() => {
    fetchUrl('fetchTenants').then((response) => {
      setTenants(response)
    });
  }, [])

  return (
    <TenantSelectionPage>
      <div className={'header'}>
        <h1>Tenant Selection</h1>
        <p>Selecting an exchange will show data for only that exchange. <Icon>help</Icon></p>
      </div>
      <div className={'tenants-container'}>
        {
          tenants.length > 0 && tenants.map((exchange) => {
            return <Tenant handleClick={handleClick} tenant={exchange} selectedTenant={tenant} />
          })
        }
      </div>
    </TenantSelectionPage>
  )
}

export default TenantSelection;